import { format } from "date-fns";

import { Location } from "redux-little-router";

export interface AdminStatistics {
    tasksToCompleteCount: number;
    appointmentsToBookCount: number;
    employeesToMatchCount: number;
    outstandingTriageCount: number;
    incompletePastAppointmentsCount: number;
    reportsToWriteCount: number;
    unassignedTasksCount: number;
    caseConversationCount: number;
    reportsToQACount: number;
    lastUpdated: Date | null;
}

export interface AdminUserStatistics {
    tasksToCompleteCount: number;
    appointmentsTodayCount: number;
    incompleteAppointmentsCount: number;
    reportsToWriteCount: number;
    caseConversationCount: number;
    lastUpdated: Date | null;
}

export interface Statistics {
    adminStatistics: AdminStatistics;
    adminUserStatistics: AdminUserStatistics;
}

export interface StatisticsState {
    readonly statistics: Statistics;
}

export type AppState = StatisticsState & { router: Location };

export const getLastUpdatedToDisplay = (date: Date | null) => {
    return date ? format(date, "dd/MM/yyyy 'at' h:mm:ss aaa") : "";
};
